module.exports = __webpack_public_path__ + "static/media/logo.00d1cca5.png";